export class ManquementSiteEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' }
    };

    id: number;
    nom: string;
    adresse: string;
    codePostal: string;
    ville: string;
    telephone: string;
}
